import React from 'react';
import classes from "./ProcessItem.module.css";

export default function ProcessItem({ img, desc }) {
    return (
        <div className={classes.item}>
            <div className={classes.img_content}>
                {img}
            </div>
            <div className={classes.description}>
                <p dangerouslySetInnerHTML={{__html: desc}} />
            </div>
        </div>
    )
}
